import { render, staticRenderFns } from "./ReceiverRootPage.vue?vue&type=template&id=6dbf99d5&scoped=true&"
import script from "./ReceiverRootPage.vue?vue&type=script&lang=js&"
export * from "./ReceiverRootPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbf99d5",
  null
  
)

export default component.exports